<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<div class="calculator">
  <header class="page-header">
    <h2>Calculadora do Parceiro</h2>
    <p class="calculator__subtitle">
      Simule a remuneração de uma captação: escolha o prazo e o valor. Os valores são estimativas e
      não ficam gravados.
    </p>
  </header>

  <div class="calculator__grid">
    <!-- Entradas ------------------------------------------------------------------ -->
    <!-- `appAutoFormGroup` junto do `[formGroup]`: sem ele o `app-input` cria controle próprio e o
         formulário do componente não recebe o que se digita (mesma lição do modal-valor-deal). -->
    <section class="calculator__card" [formGroup]="form" appAutoFormGroup>
      <h3 class="calculator__card-title">Simulação</h3>

      <!-- Prazo em botões, como na Calculadora da landing page (card 3745): são só cinco opções e um
           clique troca o resultado. O valor continua no controle `termYears` do formulário. -->
      <div class="calculator__field">
        <span class="calculator__label" id="calculator-term-label">Prazo da captação</span>
        <div class="calculator__terms" role="radiogroup" aria-labelledby="calculator-term-label">
          @for (option of termOptions; track option.value) {
            <button
              type="button"
              role="radio"
              class="calculator__term"
              [class.calculator__term--on]="termYears() === option.value"
              [attr.aria-checked]="termYears() === option.value"
              (click)="selectTerm(option.value)">
              {{ option.label }}
            </button>
          }
        </div>
      </div>

      <app-input
        label="Valor da captação"
        type="number"
        prefix="R$ "
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [formGroup]="form"
        controlName="amount" />
    </section>
  </div>

  <!-- Resultados: o backend recalcula a cada mudança ------------------------------------ -->
  <section
    class="calculator__results"
    [class.calculator__results--busy]="simulating()"
    aria-live="polite"
    [attr.aria-busy]="simulating()">
    <div class="calculator__result calculator__result--highlight">
      <span class="calculator__result-label">Sua comissão estimada</span>
      <strong class="calculator__result-value">
        {{
          simulation()
            ? (simulation()!.commissionAmount | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR')
            : '—'
        }}
      </strong>
    </div>
  </section>

  <!-- Card 3745: só a comissão aparece; fee, flat fee e o resumo "Fee | Flat Fee | Captação" saíram
       (pedido do Breno, 27/10/2026). A conta continua no backend. -->
  @if (simulationFailed()) {
    <p class="calculator__summary calculator__summary--error">
      Não foi possível calcular agora. Confira a conexão e altere o valor ou o prazo para tentar de
      novo.
    </p>
  } @else if (!simulation()) {
    <p class="calculator__summary">Escolha o prazo para ver a comissão estimada.</p>
  }
</div>
